export default "__VITE_ASSET__oWjDOCLE__"